import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Jura:wght@400;500;600;700&display=swap');

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body {
    overflow-x: hidden;
    width: 100%;
    position: relative;
  }

  html {
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    margin: 0;
    line-height: normal;
    font-family: 'Jura', sans-serif;
    color: #333;
    background-color: #fff;
    min-height: 100vh;
  }

  #___gatsby {
    overflow-x: hidden;
    width: 100%;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button, .MuiButton-root {
    border: none;
    background: none;
    cursor: pointer;
    font-family: inherit;
    font-weight: 700;
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
`;

export default GlobalStyles;
